// extracted by mini-css-extract-plugin
module.exports = {"section":"home-insights_section__1_Ylw","wrapper":"home-insights_wrapper__nNmHg","imgMobile":"home-insights_imgMobile__3EHt-","listCaption":"home-insights_listCaption__24mJV"};